import './App.css';
import PathfindingVisualizer from './screens/path/PathfindingVisualizer';

function App() {
  return (
    <PathfindingVisualizer/>
  );
}

export default App;
